import type { PublicCollectionData } from '@mogul/api-client';
import { Network } from '@mogul/api-client';
import type { FC } from 'react';
import { useEffect, useRef, useState } from 'react';

import { collectionsApi } from '../../api';
import { CollectionCard } from './collectionCard/CollectionCard.component';

interface MarketplaceProps {
  search: string;
}

export const MarketplaceListV2: FC<MarketplaceProps> = ({ search }) => {
  const [collectionList, setCollectionList] = useState<PublicCollectionData[]>(
    [],
  );
  const currentDataLengthRef = useRef<number>(0);
  const totalResultsRef = useRef<number>(0);

  const appendCollectionData = (data: PublicCollectionData[]) => {
    currentDataLengthRef.current += data.length;

    setCollectionList(prev => [...prev, ...data]);
  };

  const loadMoreResults = () => {
    if (currentDataLengthRef.current < totalResultsRef.current) {
      void collectionsApi
        .listCollections({
          limit: 12,
          offset: currentDataLengthRef.current,
          // network: getNetworkEnum(marketplace),
          searchQuery: search,
        })
        .then(results => {
          appendCollectionData(results.data.data);
          totalResultsRef.current = results.data.meta.totalCount;
        });
    }
  };

  useEffect(() => {
    const getCollection = async () => {
      const result = await collectionsApi.listCollections({
        limit: 12,
        offset: 0,
        // network: getNetworkEnum(marketplace),
        searchQuery: search,
      });
      totalResultsRef.current = result.data.meta.totalCount;
      currentDataLengthRef.current = result.data.data.length;
      setCollectionList(result.data.data);
    };

    void getCollection();
  }, [search]);

  useEffect(() => {
    const app = document.querySelector<HTMLElement>('.app-container');

    const onScroll = () => {
      if (app && app.scrollHeight - app.scrollTop === app.clientHeight) {
        loadMoreResults();
      }
    };

    if (app) {
      app.addEventListener('scroll', onScroll, { passive: true });
      return () => {
        app.removeEventListener('scroll', onScroll);
      };
    }
  }, []);

  return (
    <div className="my-10 flex flex-col gap-8 px-5 sm:px-0 pt-2">
      <div className="fontVanguard font-bold xl:text-4xl text-3xl leading-7">
        {search.length > 0
          ? `Displaying Results For: ${search}`
          : 'Collections'}
      </div>
      <div className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8 md:gap-6">
        {collectionList.map((collection, index) => {
          return <CollectionCard collectionData={collection} key={index} />;
        })}
      </div>
    </div>
  );
};
